<app-kontable
        [source]="civilStatusService.civilStatuses"
        [title]="'civilStatusList.sectionTitle' | translate"
        [columns]="['id', 'name', 'description']"
        [titles]="['common.id', 'common.name', 'common.description']"
        [showInfoButton]="false"
        [showGlobalFilter]="false"
        [showRecoverButton]="false"
        [showDetailsButton]="false"
        [showAddButton]="true"
        (onAdd)="showAddOrEditDialog(null)"
        (onEdit)="showAddOrEditDialog($event)"
        (onRemove)="delete($event)"
>
</app-kontable>

<p-dialog
          *ngIf="addEditDialog"
          header="{{modalTitle}}"
          [(visible)]="addEditDialog"
          [modal]="true"
          [resizable]="false"
          [draggable]="false"
          [width]="500"
          (onHide)="closeAddDialog()">
  <app-kv-civil-status-form
          (civilStatusAdded)="civilStatusAdded($event)"
          (civilStatusUpdated)="civilStatusUpdated($event)"
          *ngIf="civilStatusService.civilStatusEditing"
          [dialogBoxCivilStatus]="civilStatusService.civilStatusEditing"
  ></app-kv-civil-status-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/civil-status/civil-status.component.html